module.exports = __webpack_public_path__ + "img/01.328caba4.png";